export default defineNuxtPlugin(() => {
  // eslint-disable-next-line no-underscore-dangle
  window.__KIK__ = {
    goTo: (url: string) => navigateTo(url),
  };
});
